import StoreModuleService from '../../../StoreModuleService';
import { initialState } from './state';
import Vue from 'vue';
// mutations declarations
export const SET_WIDGET_MAPPING_SOURCE = 'SET_PUBLISH_LOADING';
const mutations = {
	...StoreModuleService.createDefaultMutations({ initializer: initialState }),
	[SET_WIDGET_MAPPING_SOURCE](state, payload) {
		const { fieldUUID, sourceMappings } = payload;
		Vue.set(state.mappingSourceFields, fieldUUID, sourceMappings);
	},
};

export default mutations;
